import { FORM_KEYS } from '../constants';

export const getPlannedClinic = formData => {
  const plannedClinic = formData?.['view:plannedClinic'];

  return {
    userSelected: plannedClinic?.['view:userSelected']
      ? JSON.parse(plannedClinic['view:userSelected'])
      : undefined,
    caregiverSupport: plannedClinic?.['view:caregiverSupport']
      ? JSON.parse(plannedClinic['view:caregiverSupport'])
      : undefined,
    veteranPlannedClinic: plannedClinic?.veteranPlannedClinic,
  };
};

export const mapFacility = facility => {
  if (!facility) return null;

  return {
    id: facility.id,
    name: facility.name,
    address: {
      physical: {
        address1: facility.address?.physical?.address1,
        address2: facility.address?.physical?.address2,
        address3: facility.address?.physical?.address3,
      },
    },
  };
};

export const showFacilityConfirmation = formData => {
  if (!formData[FORM_KEYS.facilitiesApi]) return false;

  const { userSelected, caregiverSupport } = getPlannedClinic(formData);

  if (!userSelected || !caregiverSupport) return false;

  return userSelected.id !== caregiverSupport.id;
};
